// A small bounded-concurrency task runner: at most `limit` tasks run at once.
// Unlike a one-shot "run over this array" helper, `push()` can be called at
// any time — including while other tasks are still in flight — which is what
// lets a user add more files to an in-progress batch without waiting for
// files already uploading/processing.
export function createConcurrencyPool(limit) {
  const queue = [];
  let active = 0;

  const onTaskSettled = () => {
    active -= 1;
    pump();
  };

  function pump() {
    while (active < limit && queue.length > 0) {
      const task = queue.shift();
      active += 1;
      // tasks are expected to self-isolate errors into their own state
      Promise.resolve(task()).catch(() => {}).finally(onTaskSettled);
    }
  }

  return {
    push(task) {
      queue.push(task);
      pump();
    },
  };
}
